'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CloseMediaPlayerIcon = require('./CloseMediaPlayerIcon');

var _CloseMediaPlayerIcon2 = _interopRequireDefault(_CloseMediaPlayerIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CloseMediaPlayerIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CloseMediaPlayerIcon/index.js
// module id = 262
// module chunks = 11